import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions';
import type { ContainerProps, IssueTypesStore } from './types';

type Actions = typeof actions;

export const initialState: IssueTypesStore = {
	data: null,
	error: null,
	isLoading: true,
	isResourceFetchComplete: false,
	isInitialCsrRenderComplete: false,
};

const store = createStore({
	actions,
	initialState,
	name: 'jira-admin-pages-issue-types-directory',
});

export const IssueTypesContainer = createContainer<IssueTypesStore, Actions, ContainerProps>(
	store,
	{
		onInit:
			() =>
			({ setState }) => {
				setState({
					isLoading: true,
				});
			},
	},
);

export const useIssueTypes = createHook(store);
export const useIssueTypesActions = createHook(store, {
	selector: null,
});
